import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import _get from 'lodash/get'
import _reverse from 'lodash/reverse'
import _orderBy from 'lodash/orderBy'
import { compose, withApollo, Query, graphql } from 'react-apollo'
import{ Row, Col, Table, Input, Select, Progress, Card, Button, Spin } from 'antd';
import '../../css/style.css'
import styled from 'styled-components'
import { FinisherWallTitle } from '../../../../../styled-components/event.js'
import withTracker from '~/hocs/withTracker.js';
import RenderChart from './renderChart'

import FusionCharts from 'fusioncharts'
import Charts from 'fusioncharts/fusioncharts.charts'
import ReactFC from 'react-fusioncharts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
import moment from 'moment'
import _groupBy from 'lodash/groupBy'
import get from 'lodash/get';
import TeamChart from '../team/renderChart'
import BarTeam from '../team/renderBarChartTeam'
import dailyTeamDistaceQuery from '../../../../../../graphql/queries/dailyTeamDistance.gql'
import raceClient from '~/apollo-clients/race'
import totalDistanceParticipantStat from '~/graphql/queries/totalDistanceParticipantStat.gql'

import calStepToKm from '~/utils/stepToKm.js';

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme)

const { Search } = Input

class Normal extends Component {
  state = {
    gender: '',
    ageRange: '',
    firstTotalDistance: 0,
    searchKey: '',
    startDate: '',
    endDate: '',
    Popover: false,
    dailyCharts: false,
    perpage: 50,
    page: 1,
    participantData: [],
    isPageChange: false,
    top5Data: [],
    racingTeamLoading: false
  }

  
  handleChangeGender = (value) => {
    this.setState({
        gender: value,
        page: 1
    });
    const { eventId, fetchMore} = this.props
    const _operators = {
      gender: value === ""
        ? {in: this.props.eventGender}
        : {in: [value]},
      ...(this.state.ageRange === ""
        ? []
        : {
          ageRange: {in: [this.state.ageRange]}
        } )
    }
    fetchMore({
      variables: {
        eventId: eventId,
        perPage: this.state.perpage,
        _operators,
        page: 1,

      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        return {
          ...fetchMoreResult
        }
      }
    })
  }
  handleChangeAgeRange = (value) => {
    this.setState({
        ageRange: value,
        page: 1
    });
    const { eventId, fetchMore } = this.props
    const _operators = {
      gender: this.state.gender === ""
        ? {in: ["male", "female", "lgbtq"]}
        : {in: [this.state.gender]},
      ...(value === ""
        ? []
        : {
          ageRange: {in: [value]}
        } )
    }
    fetchMore({
      variables: {
        eventId: eventId,
        perPage: this.state.perpage,
        _operators,
        page: 1,

      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        return {
          ...fetchMoreResult
        }
      }
    })
  }
  handleSearch = (value) => {
    const { eventId, fetchMore, raceId, chartsMode } = this.props
    const _operators = value.trim()
      ? {bibNumber: {in: [value.trim()]}}
      : {}
    let variables = {
      eventId: eventId,
      perPage: this.state.perpage,
      _operators,
      page: 1
    }
    if (raceId && chartsMode === 'regTypeTab') {
      variables = {
        eventId: eventId,
        perPage: this.state.perpage,
        _operators,
        page: 1,
        raceId
      }
    }
    this.setState({page: 1})
    fetchMore({
      variables,
      updateQuery: (previousResult, { fetchMoreResult }) => {
        return {
          ...fetchMoreResult
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    const { data, totalDistanceParticipant, raceId, chartsMode} = nextProps
    const ParticipantByRace = _get(data, 'totalDistanceParticipant')
    const firstdataTotalDistance = ParticipantByRace && ParticipantByRace.length > 0 ? ParticipantByRace[0].totalDistance : 0
    this.setState({
      firstTotalDistance: parseFloat(firstdataTotalDistance?.toFixed(2))
    })
    let totalDistanceParticipant$ = totalDistanceParticipant
    if(raceId && ['regTypeTab', 'normal'].includes(chartsMode)) {
      totalDistanceParticipant$ = _get(nextProps, 'totalDistanceParticipantStat.items')
    }
    const top5Data = totalDistanceParticipant$ && totalDistanceParticipant$
      .filter(({gender}) => {
        return this.state.gender === ""
          ? true
          : gender === this.state.gender
      })
      .filter(({
        rank, genderRank,
        regTypeTabRank, regTypeTabGenderRank,
        ageRangeRank, genderAgeRangeRank,
        regTypeTabAgeRangeRank, regTypeTabGenderAgeRangeRank,

      }) => {
        let selectedRank = this.state.gender === ""
          ? rank
          : genderRank
        
        if (raceId && ['regTypeTab', 'normal'].includes(chartsMode)) {
          selectedRank = this.state.gender === ""
            ? regTypeTabRank
            : regTypeTabGenderRank
        }
        if(this.state.ageRange !== "") {
          selectedRank = this.state.gender === ""
            ? ageRangeRank
            : genderAgeRangeRank
          if (raceId && ['regTypeTab', 'normal'].includes(chartsMode)) {
            selectedRank = this.state.gender === ""
              ? regTypeTabAgeRangeRank
              : regTypeTabGenderAgeRangeRank
          }
        }
        return selectedRank < 6
      }).slice(0, 5)
      if(top5Data && top5Data.length > 0) {
        this.setState({
          top5Data
        })
      }
  }

  render() {
    const { timeDay, totalDistanceAll, distanceUnitAll, chartsMode, registrationTypes, handleTabs, regFields, timeDayEnd , rankMode, totalRunScoreAll} = this.props
    const currentDay = moment()
    const isBwRace = currentDay.isBetween(timeDay, timeDayEnd)
    const isBefore = currentDay.isBefore(timeDay)
    const totalDays = isBefore
      ? 0
      : (isBwRace ? currentDay : timeDayEnd)
        .diff(timeDay, 'days')
    const { sumDistanceByGroup } = this.props
    let totalDistanceParticipant = _get(this.props, 'totalDistanceParticipant')
    const { raceId, nameRace, isLineLogin, eventId, slug, userCount, fetchMore, ageRanges } = this.props
    const { t } = this.props
    if(this.props.totalDistanceParticipantLoading){
      <Spin tip="Loading..."/>
    }

    if(!this.props.totalDistanceParticipantLoading && nameRace !== "All" && nameRace !== "AllTeam"){
        totalDistanceParticipant = _get(this.props.totalDistanceParticipantStat, 'items')
        totalDistanceParticipant = eventId === '6858f37b9e9f59890a8bc043' ? _orderBy(totalDistanceParticipant, ['totalDistance'], ['asc']): rankMode === 'utpscore' ? _orderBy(totalDistanceParticipant, ['totalRunningScore'], ['desc']) :  _orderBy(totalDistanceParticipant, ['totalDistance'], ['desc'])
        
    }
    if(nameRace === "All" && this.state.isPageChange){
      if(this.state.page > 1){
        totalDistanceParticipant = this.state.participantData
      }
    }
    if(chartsMode === 'regType' && nameRace === "All") {
      const stack = []
      const group = _groupBy(totalDistanceParticipant, 'firstName')
      Object.keys(group) && Object.keys(group).forEach(key => {
        const total = group[key].reduce((init, item) => {
          return {
            totalDistance: init.totalDistance + item.totalDistance,
            runnerCount: init.runnerCount + item.runnerCount,
            ticketCount: init.ticketCount + item.ticketCount,
          }
        }, {
          totalDistance: 0,
          runnerCount: 0,
          ticketCount: 0,
        })
        if(_get(total, 'totalDistance') > 0) stack.push({...group[key][0], ...total})
      });
      totalDistanceParticipant = stack
    } else if(chartsMode === 'regTypeTab' && nameRace === "AllTeam") {
      totalDistanceParticipant = sumDistanceByGroup
    }
    const searchParticipant = totalDistanceParticipant
    const filterGender = searchParticipant
    const filterDateData = filterGender
    let filterRaceData = eventId === '6858f37b9e9f59890a8bc043' ? _orderBy(filterDateData, ['totalDistance'], ['asc']) : rankMode === 'utpscore'? _orderBy(filterDateData, ['totalRunningScore'], ['desc']) :filterDateData
    let filterData = filterRaceData && filterRaceData.map((participant) => ({ ...participant}))
    // const totalRunningScore = Number(totalRunScoreAll)
    // filterData &&  filterData.reduce((total,item) => {
    //   return  item.totalRunningScore ? total + item.totalRunningScore: total + 0
    // }, 0)

    console.log(totalRunScoreAll, 'totalRunningScore');

    if (chartsMode === 'regTypeTab' && nameRace ==='AllTeam') {
      filterData = filterData && filterData.filter((data)=> data.raceId !== '62021fc7aaca59c0315039ac').map((data) => {
        const regTypeName = registrationTypes && _get(
          registrationTypes.find(rt =>
            `${rt._id}` === `${_get(data, 'raceId')}`
          )
        , 'name.en')
        const optionHidden = registrationTypes && _get(
          registrationTypes.find(rt =>
            `${rt._id}` === `${_get(data, 'raceId')}`
          )
        , 'optionHidden')
        return {
          ...data,
          firstName: regTypeName,
          lastName: '',
          optionHidden
        }
      })
      
      filterData = filterData.filter((data) => data.firstName !== 'ประเภทเดี่ยว' && data.optionHidden === false)
      filterData = _orderBy(filterData, [rankMode === 'utpscore' ? 'totalRunningScore' : 'totalDistance'], [eventId === '6858f37b9e9f59890a8bc043' ? 'asc' : 'desc']
)
      console.log(filterData, 'filterData');
    }

    let countUser = filterData && filterData.length
    if(nameRace === 'All'){
      countUser = userCount
    }

    if(chartsMode === 'race') {
      countUser = filterData.reduce((i, c) => i + c.runnerCount, 0)
    } else if(chartsMode === 'regType') {
      countUser = _get(totalDistanceParticipant, [0, 'allRunnerCount']) || 0
    } else if(chartsMode === 'regTypeTab' && nameRace ==='AllTeam' ) {
      countUser = _get(registrationTypes, ['length']) || 0
    } else if (['regTypeTab', 'normal'].includes(chartsMode)) {
      countUser = _get(this.props.totalDistanceParticipantStat, 'count')
    }
    let graphData
    let graphTeamData
    if(_get(sumDistanceByGroup, 'length') !==0 && nameRace ==='AllTeam' && chartsMode !== 'regTypeTab'){
      const sortsumDistanceByGroup = _orderBy(sumDistanceByGroup,
        [rankMode === 'utpscore' ? 'totalRunningScore' : 'totalDistance'],
        [eventId === '6858f37b9e9f59890a8bc043' ? 'asc' : 'desc']
      )
      countUser = _get(sumDistanceByGroup, 'length')
      const lastRaceDistance = (raceId) => {
        const record = filterData.filter(participant => participant.raceId === raceId).sort((a,b) => (moment(b.date, 'DD/MM/YYYY')-moment(a.date, 'DD/MM/YYYY')))
        return { distance: record[0].distance, date: record[0].date }
      }
      filterData = sortsumDistanceByGroup
        .map(({name, totalDistance, raceId, distanceUnit, rank, genderRank , totalRunningScore}, index) =>
        ({
          firstName: get(name, 'en'),
          lastName: '',
          distance: lastRaceDistance(raceId).distance,
          totalDistance,
          distanceUnit: rankMode === 'utpscore' ? 'points' : distanceUnit,
          date: lastRaceDistance(raceId).date,
          raceId,
          rank,
          totalRunningScore
        }))

      graphData = sortsumDistanceByGroup.map(({ name, totalDistance, imageUrl, distanceUnit, totalRunningScore }) => (
        { 
          label: _get(name, 'en'), 
          value: parseFloat(totalDistance?.toFixed(2)), 
          imageUrl,
          distanceUnit: rankMode === 'utpscore' ? 'points' : distanceUnit,
          totalRunningScore
        }
      )).slice(0, 5)
    }
    else {
      const data$ = this.state.top5Data.length > 0 && nameRace !=='AllTeam'
        ? this.state.top5Data
        : filterData
        const sortData = _orderBy(
          data$,
          [rankMode === 'utpscore' ? 'totalRunningScore' : 'totalDistance'],
          [eventId === '6858f37b9e9f59890a8bc043' ? 'asc' : 'desc']
        )
      graphData = data$ && sortData.filter((data)=> data.firstName !== 'สมัครโดยใช้โค้ดพิเศษ' && data.firstName !== 'ประเภทเดี่ยว')
        .map(({ firstName, totalDistance, imageUrl, distanceUnit,totalRunningScore }) => (
        { 
          label: firstName, 
          value: parseFloat(totalDistance?.toFixed(2)), 
          imageUrl,
          distanceUnit: rankMode === 'utpscore' ? 'points' : distanceUnit,
          totalRunningScore
        }
      )).slice(0, 5)
    }

    if (graphData && graphData.length > 1) {
      _reverse(graphData)
      graphTeamData = graphData
    
      if(graphData.length > 4) {
        const _5th = graphData && graphData.shift()
        const _4th = graphData && graphData.shift()
        const _3rd = graphData && graphData.shift()
        graphData && graphData.push(_3rd)
        graphData && graphData.push(_5th)
        graphData && graphData.splice(0, 0, _4th)
      }
      else if(graphData.length === 4) {
        const _4th = graphData && graphData.shift()
        const _3rd = graphData && graphData.shift()
        graphData && graphData.push(_3rd)
        graphData && graphData.splice(0, 0, _4th)
      }
      else if(graphData.length < 4 && graphData.length > 2) {
        const _3rd = graphData && graphData.shift()
        graphData && graphData.push(_3rd)
      }
    }

    const itemRender = (current, type, originalElement) => {
      if (type === 'prev') {
        return <a style={{marginRight: '5px'}} className="resultfont"><i aria-label="icon: left" class="anticon anticon-left"><svg viewBox="64 64 896 896" class="" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></i>Prev </a>;
      }
      if (type === 'next') {
        return <a style={{marginRight: '5px', marginLeft: '5px'}} className="resultfont">Next <i aria-label="icon: right" class="anticon anticon-right"><svg viewBox="64 64 896 896" class="" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"></path></svg></i></a>;
      }
      return originalElement;
    }

    const onLoadMore = (page) => {
      this.setState({page: page})
      const _operators = this.state.gender === ""
      ? {gender: {in: ["male", "female", "lgbtq"]}}
      : {gender: {in: [this.state.gender]}}
      fetchMore({
        variables: {
          eventId: eventId,
          perPage: this.state.perpage,
          _operators,
          page: page
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return {
            ...fetchMoreResult
          }
        }
      })
    }

    const handleChangeTeamChart = () => {
      this.setState({
        dailyCharts: !this.state.dailyCharts,
      });
    }

    const columns = [
        {
          title: t('finisherwall.detail'),
          key: 'firstName',
          render: (filterData) => {
            const firstName = _get(filterData, 'firstName')
            const lastName = _get(filterData, 'lastName')
            const ticketCount = _get(filterData, 'ticketCount')
            const totalDistance = _get(filterData, 'totalDistance')
            const totalRunningScore = _get(filterData, 'totalRunningScore')
            const distanceUnit = rankMode === 'utpscore' ? 'points' : _get(filterData, 'distanceUnit')
            let rank = this.state.gender === ""
              ? _get(filterData, 'rank')
              : _get(filterData, 'genderRank')
            if (raceId && ['regTypeTab', 'normal'].includes(chartsMode)) {
              rank = this.state.gender === ""
                ? _get(filterData, 'regTypeTabRank')
                : _get(filterData, 'regTypeTabGenderRank')
            }
            if(this.state.ageRange !== "") {
              rank = this.state.gender === ""
                ? _get(filterData, 'ageRangeRank')
                : _get(filterData, 'genderAgeRangeRank')
              if (raceId && ['regTypeTab', 'normal'].includes(chartsMode)) {
                rank = this.state.gender === ""
                  ? _get(filterData, 'regTypeTabAgeRangeRank')
                  : _get(filterData, 'regTypeTabGenderAgeRangeRank')
              }
            }
            const raceIdc = _get(filterData, 'raceId')
            const raceDistance = chartsMode === 'regTypeTab' && nameRace ==='AllTeam' && _get(filterData, 'teamDistance') && _get(filterData, 'teamDistance') > 0 ? _get(filterData, 'teamDistance') : _get(filterData, 'raceDistance')
            const divide = chartsMode === 'regTypeTab' && nameRace ==='AllTeam' && _get(filterData, 'teamDistance') && _get(filterData, 'teamDistance') > 0 ? _get(filterData, 'teamDistance') :(raceDistance > 1 ? raceDistance : this.state.firstTotalDistance)
            const progressDistance = (totalDistance * 100) / divide
            const distance = _get(filterData, 'distance')
            const date = _get(filterData, 'date')
            const Details = <Row className="table-result">
              <Col>
                <span className="resultfont">{t('finisherwall.resultall')}</span>
                <span className="resultfont"> {rankMode === 'utpscore'? totalRunningScore?.toFixed(2) : totalDistance?.toFixed(2)}</span>
                <span className="resultfont"> {distanceUnit}</span>
                {slug === 'ac_pm2024' &&<span className="resultfont"> ({calStepToKm(totalDistance)} km)</span>}
                {rankMode === 'utpscore' && <span className="resultfont"> ({totalDistance?.toFixed(2)} km.)</span>}
                {/* <i> {isLineLogin ? ` (จำนวนผู้สมัคร ${ticketCount} คน)` : '' }</i> */}
              </Col>
              <Col style={{ color: '#bfbfbf' }} className="resultfont">
                {`${t('finisherwall.lastresult')} ${parseFloat(distance?.toFixed(2)).toLocaleString()} ${distanceUnit || 'km'}, ${date}`}
              </Col>
            
          </Row>
            return <Row type="flex" justify="space-around">
            <Col lg={2} xs={4} className="col-result">
              <h1 className="ranktitle">{rank}</h1>
            </Col>
            <Col lg={7} xs={20} className="col-result">
              <h3>{nameRace ==='AllTeam' && raceIdc ?<a onClick={()=> handleTabs(`${raceIdc}`)}>{`${firstName} ${lastName}`}</a>: `${firstName} ${lastName}`}</h3>
            </Col>
            <Col lg={7} xs={24} className="col-result">
              <Progress 
                percent={parseFloat(progressDistance?.toFixed(2))} 
                className="progress-tableGroupRace"
                format={percent => `${percent} %`}
              />
            </Col>
            <Col lg={8} xs={24}>
              {Details}
            </Col>
          </Row>
          }
        }
      ];
    return (    
        <Row type="flex" justify="center" style={{ backgroundColor: '#FAFAFA' }}>
          <Col xs={24}>
            <Card className="event-box-shadow" bordered={true} style={{ width: '100%'}}>
              {graphData && graphData.length !== 0 ? nameRace ==='AllTeam' && this.state.dailyCharts ? <TeamChart eventId={eventId} graphTeamData={graphTeamData} chartsMode={chartsMode} /> :
                slug === 'vr1000kay' && nameRace ==='AllTeam' ? <Query 
                  query={dailyTeamDistaceQuery}
                  client={raceClient}
                  variables={{
                    eventId: eventId
                  }}>{({ data, loading, error }) => {
                    if(loading) {
                      return <div style={{ display: 'flex', justifyContent:'center' }}><Spin tip="Loading..."/></div>
                    }
                    if(error) {
                      return <div>Error</div>
                    }
                    const { TeamDaily } = data
                    const graphDataTop50 = TeamDaily.map(({ name, total }) => (
                      { 
                        label: name, 
                        value: parseFloat(total[total.length -1].toFixed(2)),
                        distanceUnit: rankMode === 'utpscore' ? 'points' : 'km',
                        
                      }
                    ))
                    let sortgraphDataTop50 = _orderBy(graphDataTop50, ['value'], ['desc']).slice(0, 5)
                    if (sortgraphDataTop50 && sortgraphDataTop50.length > 1) {
                      _reverse(sortgraphDataTop50)
                      
                      if(sortgraphDataTop50.length > 4) {
                        const _5th = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        const _4th = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        const _3rd = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        sortgraphDataTop50 && sortgraphDataTop50.push(_3rd)
                        sortgraphDataTop50 && sortgraphDataTop50.push(_5th)
                        sortgraphDataTop50 && sortgraphDataTop50.splice(0, 0, _4th)
                      }
                      else if(sortgraphDataTop50.length === 4) {
                        const _4th = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        const _3rd = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        sortgraphDataTop50 && sortgraphDataTop50.push(_3rd)
                        sortgraphDataTop50 && sortgraphDataTop50.splice(0, 0, _4th)
                      }
                      else if(sortgraphDataTop50.length < 4 && sortgraphDataTop50.length > 2) {
                        const _3rd = sortgraphDataTop50 && sortgraphDataTop50.shift()
                        sortgraphDataTop50 && sortgraphDataTop50.push(_3rd)
                      }
                    }
                    return <RenderChart
                    dataSource={sortgraphDataTop50}
                    eventId={eventId}
                    />
                  }} 
                </Query>:
                <RenderChart
                  dataSource={graphData}
                  rankMode = {rankMode}
                  eventId={eventId}/> :
                <h2>ยังไม่มีนักวิ่งส่งผล</h2>}
            </Card>
          </Col>

          <Col xs={24}>
            <Row type="flex" style={{ backgroundColor: '#FAFAFA'}}>
              <Col xs={24} lg={rankMode === 'utpscore' ? 5 : 7}  className="event-box-shadow" style={{ backgroundColor: '#fff', padding: '20px 5px', marginBottom: '15px', marginTop: '15px' }}>
                  <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Col md={12} xs={rankMode === 'utpscore' ? 5 : 7} className="text-faRunning">
                      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px' }}>
                        {slug !== 'tucufootrun' ? <><h5 className="txt-running">{t('finisherwall.submmitCount')}</h5>
                        <div>
                          <h1 className="txt-running-sub">
                            {countUser} {nameRace === 'AllTeam' ?
                              t('finisherwall.teams') :
                              t('finisherwall.runner')
                            }</h1>
                        </div></>: <div></div>}
                      </div>
                    </Col>
                    <Col md={12} xs={rankMode === 'utpscore' ? 5 : 7} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <div className="circle-icon" style={{backgroundColor: 'rgb(224 245 252)'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30pt" height="46pt" viewBox="0 0 46 46" version="1.1">
                          <g id="surface1">
                            <path fill="rgb(2 173 224)" d="M 15.105469 1.582031 C 15.890625 1.582031 16.628906 1.890625 17.183594 2.441406 C 17.738281 2.996094 18.046875 3.738281 18.046875 4.519531 C 18.046875 5.304688 17.738281 6.042969 17.183594 6.597656 C 16.972656 6.800781 16.9375 7.125 17.097656 7.367188 L 17.175781 7.460938 L 20.5 10.785156 C 20.703125 10.988281 21.019531 11.019531 21.257812 10.859375 L 21.351562 10.785156 L 25.160156 6.976562 L 25.378906 6.976562 L 30.871094 12.464844 L 30.871094 12.6875 L 27.730469 15.828125 C 26.9375 16.617188 26.40625 17.625 26.207031 18.722656 C 26.023438 19.707031 26.109375 20.703125 26.453125 21.632812 L 26.59375 21.976562 L 27.449219 23.890625 L 29.304688 24.050781 C 30.96875 24.1875 32.542969 24.855469 33.792969 25.957031 L 34.097656 26.242188 L 34.367188 26.523438 C 35.59375 27.851562 36.316406 29.574219 36.40625 31.382812 L 36.417969 31.769531 L 36.417969 32.789062 C 36.417969 34.707031 34.921875 36.28125 33.035156 36.410156 L 32.789062 36.417969 L 21.074219 36.371094 L 2.644531 17.953125 C 1.960938 17.273438 1.582031 16.347656 1.582031 15.386719 C 1.582031 14.523438 1.882812 13.707031 2.429688 13.058594 L 2.644531 12.820312 L 13.027344 2.441406 C 13.582031 1.890625 14.320312 1.582031 15.105469 1.582031 Z M 4.308594 14.464844 C 3.839844 14.921875 3.789062 15.652344 4.1875 16.171875 L 4.296875 16.296875 L 22.023438 34.082031 L 32.789062 34.082031 C 33.390625 34.082031 33.898438 33.667969 34.039062 33.109375 L 34.070312 32.941406 L 22.75 32.902344 Z M 25.269531 10.167969 L 23.003906 12.433594 C 22.449219 12.988281 21.710938 13.296875 20.925781 13.296875 C 20.230469 13.296875 19.566406 13.054688 19.039062 12.609375 L 18.847656 12.4375 L 17.785156 11.375 L 17.742188 24.589844 L 23.699219 30.609375 L 33.949219 30.601562 L 33.90625 30.417969 C 33.71875 29.679688 33.375 28.992188 32.898438 28.394531 L 32.648438 28.105469 C 31.808594 27.191406 30.675781 26.59375 29.449219 26.417969 L 29.109375 26.378906 L 25.972656 26.109375 L 25.839844 26.019531 L 24.691406 23.453125 L 21.65625 23.453125 L 21.496094 23.292969 L 21.496094 21.273438 L 21.65625 21.117188 L 23.902344 21.117188 L 23.855469 20.847656 C 23.789062 20.386719 23.765625 19.921875 23.78125 19.457031 L 23.800781 19.164062 L 20.855469 19.164062 L 20.699219 19.007812 L 20.699219 16.984375 L 20.855469 16.828125 L 24.335938 16.828125 L 24.449219 16.546875 C 24.78125 15.789062 25.234375 15.09375 25.789062 14.476562 L 26.078125 14.175781 L 27.675781 12.574219 Z M 15.105469 3.921875 C 14.988281 3.917969 14.871094 3.953125 14.773438 4.019531 L 14.679688 4.097656 L 12.78125 5.929688 L 12.738281 19.585938 L 15.453125 22.300781 L 15.496094 9.082031 C 15.027344 8.605469 14.738281 7.984375 14.675781 7.320312 L 14.660156 7.035156 C 14.660156 6.25 14.96875 5.511719 15.519531 4.957031 C 15.636719 4.84375 15.703125 4.6875 15.707031 4.527344 C 15.707031 4.367188 15.644531 4.210938 15.53125 4.097656 C 15.417969 3.984375 15.265625 3.921875 15.105469 3.921875 Z M 10.445312 8.328125 L 5.960938 12.808594 L 10.445312 17.292969 Z M 10.445312 8.328125 "/>
                          </g>
                        </svg>
                      </div>
                     

                    </Col>
                    
                  </Row>
              </Col>

              <Col xs={24} lg={rankMode === 'utpscore' ? 6 : 8}  className="event-box-shadow" style={{ backgroundColor: '#fff', padding: '20px 5px', marginLeft: '5px', marginBottom: '15px', marginTop: '15px' }}>
                  <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                    <Col md={12} xs={rankMode === 'utpscore' ? 6 : 8} className="text-faRunning">                                             
                      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px' }}>
                        <h5 className="txt-running">{t('finisherwall.submmitTime')}</h5>
                        <div>
                          <h1 className="txt-running-sub">{`${totalDays} Days`}</h1>
                        </div>
                      </div>
                    </Col>
                    <Col md={12} xs={rankMode === 'utpscore' ? 6 : 8} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <div className="circle-icon" style={{backgroundColor: 'rgb(255 245 229)'}}>
                        <svg xmlns="http://www.w3.org/2000/svg"  width="30pt" height="46pt" viewBox="0 0 46 46" version="1.1">
                          <g id="surface1">
                            <path fill="rgb(249 161 21)" d="M 13.417969 3.832031 C 12.359375 3.832031 11.5 4.691406 11.5 5.75 L 11.5 7.667969 L 9.582031 7.667969 C 7.476562 7.667969 5.75 9.390625 5.75 11.5 L 5.75 38.332031 C 5.75 40.441406 7.476562 42.167969 9.582031 42.167969 L 36.417969 42.167969 C 38.523438 42.167969 40.25 40.441406 40.25 38.332031 L 40.25 11.5 C 40.25 9.390625 38.523438 7.667969 36.417969 7.667969 L 34.5 7.667969 L 34.5 5.75 C 34.5 4.691406 33.640625 3.832031 32.582031 3.832031 C 31.523438 3.832031 30.667969 4.691406 30.667969 5.75 L 30.667969 7.667969 L 15.332031 7.667969 L 15.332031 5.75 C 15.332031 4.691406 14.476562 3.832031 13.417969 3.832031 Z M 9.582031 17.25 L 36.417969 17.25 L 36.417969 38.332031 L 9.582031 38.332031 Z M 24.207031 21.089844 C 24.070312 21.070312 23.933594 21.085938 23.804688 21.132812 L 18.476562 23.046875 C 17.738281 23.332031 17.25 24.042969 17.25 24.835938 L 17.25 25.398438 C 17.25 26.386719 18.226562 27.078125 19.160156 26.75 L 21.082031 26.078125 L 21.082031 33.542969 C 21.082031 34.070312 21.511719 34.5 22.042969 34.5 L 23.957031 34.5 C 24.488281 34.5 24.917969 34.070312 24.917969 33.542969 L 24.917969 21.914062 C 24.917969 21.480469 24.59375 21.148438 24.207031 21.089844 Z M 24.207031 21.089844 "/>
                          </g>
                        </svg>
                      </div>
                    </Col>
                  </Row>
              </Col>

              <Col xs={24} lg={rankMode === 'utpscore' ? 6 : 8}  className="event-box-shadow" style={{ backgroundColor: '#fff', padding: '20px 5px', marginLeft: '5px', marginBottom: '15px', marginTop: '15px' }}>
                  <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Col md={12} xs={rankMode === 'utpscore' ? 6 : 8} className="text-faRunning">
                      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px' }}>
                        <h5 className="txt-running">{eventId ==='6448d11c1aa51339842173a1' ? 'รวม': t('finisherwall.totaldistance')}</h5>
                        <div>
                          <h1 className="txt-running-sub">{totalDistanceAll} {distanceUnitAll || 'km'}</h1>
                          {slug === 'ac_pm2024' && <h2 style={{ fontSize: '24px'}}>({totalDistanceAll && calStepToKm(totalDistanceAll)} km)</h2>}
                        </div>
                      </div>
                    </Col>
                    <Col md={12} xs={rankMode === 'utpscore' ? 6 : 8} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <div className="circle-icon" style={{backgroundColor: 'rgb(255 241 241)'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30pt" height="46pt" viewBox="0 0 46 46" version="1.1">
                          <g id="surface1">
                            <path fill="rgb(255 143 143)" d="M 22.917969 1.917969 C 23.203125 1.917969 23.480469 2.003906 23.71875 2.164062 L 23.890625 2.304688 L 24.023438 2.449219 L 29.917969 9.835938 L 33.078125 6.660156 C 33.238281 6.5 33.433594 6.378906 33.652344 6.3125 L 33.871094 6.261719 L 34.09375 6.242188 C 34.320312 6.242188 34.542969 6.300781 34.746094 6.40625 L 34.945312 6.535156 L 35.101562 6.675781 L 43.261719 15.113281 C 43.390625 15.246094 43.488281 15.402344 43.492188 15.484375 C 43.933594 15.796875 44.15625 16.335938 44.066406 16.871094 C 43.976562 17.40625 43.585938 17.839844 43.066406 17.988281 L 42.863281 18.035156 L 42.667969 18.046875 L 31.453125 18.046875 L 37.902344 42.304688 C 38.066406 42.914062 37.808594 43.554688 37.269531 43.878906 L 37.082031 43.972656 L 36.898438 44.035156 C 36.296875 44.195312 35.660156 43.941406 35.332031 43.410156 L 35.234375 43.222656 L 35.167969 43.03125 L 28.527344 18.046875 L 17.492188 18.046875 L 10.847656 43.03125 C 10.722656 43.503906 10.359375 43.878906 9.890625 44.023438 L 9.691406 44.066406 L 9.480469 44.082031 C 8.71875 44.082031 8.09375 43.472656 8.070312 42.707031 L 8.078125 42.496094 L 8.113281 42.304688 L 14.566406 18.050781 L 3.332031 18.050781 C 2.695312 18.050781 2.136719 17.625 1.964844 17.011719 L 1.929688 16.828125 L 1.917969 16.636719 C 1.917969 16.039062 2.289062 15.519531 2.835938 15.3125 L 3.027344 15.257812 L 3.101562 15.285156 L 11.15625 6.6875 C 11.324219 6.507812 11.539062 6.375 11.777344 6.304688 L 11.960938 6.261719 L 12.179688 6.242188 C 12.425781 6.242188 12.667969 6.304688 12.886719 6.429688 L 13.042969 6.53125 L 13.207031 6.671875 L 16.074219 9.636719 L 21.8125 2.449219 C 21.988281 2.226562 22.226562 2.0625 22.496094 1.980469 L 22.703125 1.933594 L 22.914062 1.917969 Z M 23.007812 37.90625 C 23.636719 37.910156 24.1875 38.324219 24.367188 38.921875 L 24.410156 39.128906 L 24.425781 39.324219 L 24.425781 40.222656 C 24.425781 40.925781 23.910156 41.519531 23.214844 41.621094 C 22.515625 41.722656 21.851562 41.292969 21.65625 40.621094 L 21.609375 40.414062 L 21.59375 40.222656 L 21.59375 39.324219 C 21.59375 38.542969 22.226562 37.90625 23.007812 37.90625 Z M 23.007812 31.707031 C 23.640625 31.707031 24.1875 32.125 24.367188 32.722656 L 24.410156 32.925781 L 24.425781 33.121094 L 24.425781 34.425781 C 24.425781 35.128906 23.910156 35.726562 23.214844 35.828125 C 22.515625 35.925781 21.851562 35.5 21.65625 34.824219 L 21.609375 34.621094 L 21.59375 34.425781 L 21.59375 33.121094 C 21.59375 32.339844 22.226562 31.707031 23.007812 31.707031 Z M 23.007812 25.503906 C 23.640625 25.503906 24.1875 25.921875 24.367188 26.519531 L 24.410156 26.722656 L 24.425781 26.917969 L 24.425781 28.222656 C 24.425781 28.925781 23.910156 29.523438 23.214844 29.625 C 22.515625 29.726562 21.851562 29.296875 21.65625 28.625 L 21.609375 28.417969 L 21.59375 28.222656 L 21.59375 26.917969 C 21.59375 26.136719 22.226562 25.503906 23.007812 25.503906 Z M 23.007812 19.300781 C 23.640625 19.300781 24.1875 19.71875 24.367188 20.316406 L 24.410156 20.519531 L 24.425781 20.714844 L 24.425781 22.019531 C 24.425781 22.722656 23.910156 23.320312 23.214844 23.421875 C 22.515625 23.523438 21.851562 23.097656 21.65625 22.421875 L 21.609375 22.214844 L 21.59375 22.019531 L 21.59375 20.714844 C 21.59375 19.933594 22.226562 19.300781 23.007812 19.300781 Z M 12.203125 9.707031 L 7.035156 15.222656 L 11.5625 15.292969 L 14.296875 11.867188 Z M 34.070312 9.671875 L 31.691406 12.0625 L 34.121094 15.21875 L 39.429688 15.21875 Z M 22.914062 5.597656 L 15.242188 15.21875 L 30.59375 15.21875 Z M 22.914062 5.597656 "/>
                          </g>
                        </svg>
                      </div>
                    </Col>
                    
                  </Row>
              </Col>
              
              { rankMode === 'utpscore' && <Col xs={24} lg={6}  className="event-box-shadow" style={{ backgroundColor: '#fff', padding: '20px 5px', marginLeft: '5px', marginBottom: '15px', marginTop: '15px' }}>
                  <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Col md={12} xs={6} className="text-faRunning">
                      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '20px' }}>
                        <h5 className="txt-running">{t('finisherwall.submitScore')}</h5>
                        <div>
                          <h1 className="txt-running-sub">{totalRunScoreAll} {'points'}</h1>
                        </div>
                      </div>
                    </Col>
                    <Col md={12} xs={6} style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <div className="circle-icon" style={{backgroundColor: 'rgb(255 241 241)'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30pt" height="46pt" viewBox="0 0 46 46" version="1.1">
                          <g id="surface1">
                            <path fill="rgb(255 143 143)" d="M 22.917969 1.917969 C 23.203125 1.917969 23.480469 2.003906 23.71875 2.164062 L 23.890625 2.304688 L 24.023438 2.449219 L 29.917969 9.835938 L 33.078125 6.660156 C 33.238281 6.5 33.433594 6.378906 33.652344 6.3125 L 33.871094 6.261719 L 34.09375 6.242188 C 34.320312 6.242188 34.542969 6.300781 34.746094 6.40625 L 34.945312 6.535156 L 35.101562 6.675781 L 43.261719 15.113281 C 43.390625 15.246094 43.488281 15.402344 43.492188 15.484375 C 43.933594 15.796875 44.15625 16.335938 44.066406 16.871094 C 43.976562 17.40625 43.585938 17.839844 43.066406 17.988281 L 42.863281 18.035156 L 42.667969 18.046875 L 31.453125 18.046875 L 37.902344 42.304688 C 38.066406 42.914062 37.808594 43.554688 37.269531 43.878906 L 37.082031 43.972656 L 36.898438 44.035156 C 36.296875 44.195312 35.660156 43.941406 35.332031 43.410156 L 35.234375 43.222656 L 35.167969 43.03125 L 28.527344 18.046875 L 17.492188 18.046875 L 10.847656 43.03125 C 10.722656 43.503906 10.359375 43.878906 9.890625 44.023438 L 9.691406 44.066406 L 9.480469 44.082031 C 8.71875 44.082031 8.09375 43.472656 8.070312 42.707031 L 8.078125 42.496094 L 8.113281 42.304688 L 14.566406 18.050781 L 3.332031 18.050781 C 2.695312 18.050781 2.136719 17.625 1.964844 17.011719 L 1.929688 16.828125 L 1.917969 16.636719 C 1.917969 16.039062 2.289062 15.519531 2.835938 15.3125 L 3.027344 15.257812 L 3.101562 15.285156 L 11.15625 6.6875 C 11.324219 6.507812 11.539062 6.375 11.777344 6.304688 L 11.960938 6.261719 L 12.179688 6.242188 C 12.425781 6.242188 12.667969 6.304688 12.886719 6.429688 L 13.042969 6.53125 L 13.207031 6.671875 L 16.074219 9.636719 L 21.8125 2.449219 C 21.988281 2.226562 22.226562 2.0625 22.496094 1.980469 L 22.703125 1.933594 L 22.914062 1.917969 Z M 23.007812 37.90625 C 23.636719 37.910156 24.1875 38.324219 24.367188 38.921875 L 24.410156 39.128906 L 24.425781 39.324219 L 24.425781 40.222656 C 24.425781 40.925781 23.910156 41.519531 23.214844 41.621094 C 22.515625 41.722656 21.851562 41.292969 21.65625 40.621094 L 21.609375 40.414062 L 21.59375 40.222656 L 21.59375 39.324219 C 21.59375 38.542969 22.226562 37.90625 23.007812 37.90625 Z M 23.007812 31.707031 C 23.640625 31.707031 24.1875 32.125 24.367188 32.722656 L 24.410156 32.925781 L 24.425781 33.121094 L 24.425781 34.425781 C 24.425781 35.128906 23.910156 35.726562 23.214844 35.828125 C 22.515625 35.925781 21.851562 35.5 21.65625 34.824219 L 21.609375 34.621094 L 21.59375 34.425781 L 21.59375 33.121094 C 21.59375 32.339844 22.226562 31.707031 23.007812 31.707031 Z M 23.007812 25.503906 C 23.640625 25.503906 24.1875 25.921875 24.367188 26.519531 L 24.410156 26.722656 L 24.425781 26.917969 L 24.425781 28.222656 C 24.425781 28.925781 23.910156 29.523438 23.214844 29.625 C 22.515625 29.726562 21.851562 29.296875 21.65625 28.625 L 21.609375 28.417969 L 21.59375 28.222656 L 21.59375 26.917969 C 21.59375 26.136719 22.226562 25.503906 23.007812 25.503906 Z M 23.007812 19.300781 C 23.640625 19.300781 24.1875 19.71875 24.367188 20.316406 L 24.410156 20.519531 L 24.425781 20.714844 L 24.425781 22.019531 C 24.425781 22.722656 23.910156 23.320312 23.214844 23.421875 C 22.515625 23.523438 21.851562 23.097656 21.65625 22.421875 L 21.609375 22.214844 L 21.59375 22.019531 L 21.59375 20.714844 C 21.59375 19.933594 22.226562 19.300781 23.007812 19.300781 Z M 12.203125 9.707031 L 7.035156 15.222656 L 11.5625 15.292969 L 14.296875 11.867188 Z M 34.070312 9.671875 L 31.691406 12.0625 L 34.121094 15.21875 L 39.429688 15.21875 Z M 22.914062 5.597656 L 15.242188 15.21875 L 30.59375 15.21875 Z M 22.914062 5.597656 "/>
                          </g>
                        </svg>
                      </div>
                    </Col>
                    
                  </Row>
              </Col>}

            </Row>
          </Col>
          {true && <React.Fragment>
            <Col xs={24} style={{ marginTop: '0px', backgroundColor: '#FAFAFA'}}>
            {!isLineLogin && <Row type="flex" justify="space-between" style={{ padding: '0px 0px' }}>
                <Col xs={8} lg={8} offset={1}>
                  <FinisherWallTitle>
                    <h1 className="font-time-FinisherWall">Finisher</h1>
                    <h3 className="font-sub-FinisherWall" style={{marginLeft: '5px'}}>wall</h3>
                  </FinisherWallTitle>
                </Col>
                <Col xs={24} lg={10} style={{ textAlign: 'center' }}>
                  {!(chartsMode === 'regTypeTab' && nameRace === "AllTeam") && regFields['gender'] && <Select 
                        placeholder="เพศ" 
                        defaultValue=""
                        value={this.state.gender}
                        style={{ 
                          width:  100,
                          marginRight: 10
                        }} 
                        onChange={this.handleChangeGender}
                    >
                        <Select.Option key="" value="">
                        {t('finisherwall.gender')}
                        </Select.Option>
                        {this.props.eventGender.map(f =>
                          <Select.Option key={f} value={f === 'ชาย' ? 'male' : f === 'หญิง' ? 'female' : 'lgbtq'}>
                            {f === 'ชาย' ? t('finisherwall.male') : f === 'หญิง' ? t('finisherwall.female') : t('finisherwall.LGBTQ+')}
                          </Select.Option>
                        )}
                    </Select>}
                    {!(chartsMode === 'regTypeTab' && nameRace === "AllTeam") && _get(ageRanges, 'length') > 0 && regFields['gender'] && <Select 
                        placeholder="อายุ" 
                        defaultValue=""
                        value={this.state.ageRange}
                        style={{ 
                          width:  100,
                          marginRight: 10
                        }} 
                        onChange={this.handleChangeAgeRange}
                    >
                        <Select.Option key="" value="">
                        อายุ
                        </Select.Option>
                        {ageRanges && ageRanges.map(ageRange => {
                          return <Select.Option key={ageRange} value={ageRange}>
                            {ageRange}
                          </Select.Option>
                        })}
                    </Select>}
                    {chartsMode === 'regTypeTab' && nameRace === "AllTeam" ? '' :<Search
                        id="myInput" 
                        placeholder={t('finisherwall.searchBibHolder')} 
                        title="Type in a name" 
                        onSearch={this.handleSearch}
                        style={{ 
                          width: '300px', 
                          maxWidth: 300,
                          borderRadius: '20px'
                        }}
                        enterButton
                    />}
                </Col>
              </Row>}
            </Col>
            <Col xs={24} lg={24} style={{ padding: '10px 0', backgroundColor: '#FAFAFA' }}>
       
                {chartsMode === 'regTypeTab' && nameRace === "AllTeam" && slug !== 'vr1000kay' ?
                  <BarTeam dataSource={filterData} distanceUnit={filterData[0].distanceUnit} rankMode={rankMode}/>
                  : slug === 'vr1000kay' && nameRace ==='AllTeam' ? <Query 
                    query={dailyTeamDistaceQuery}
                    
                    client={raceClient}
                    variables={{
                      eventId: eventId
                    }}>{({ data, loading, error }) => {
                      if(loading) {
                        return <div style={{ display: 'flex', justifyContent:'center' }}><Spin tip="Loading..."/></div>
                      }
                      if(error) {
                        return <div>Error</div>
                      }
                      const { TeamDaily } = data
                      const filterTop50Data = TeamDaily.map(({ name, total}) => (
                        { 
                          firstName: name, 
                          totalDistance: parseFloat(total[total.length -1].toFixed(2)),
                        }
                      ))
                      const Top50Data = _orderBy(filterTop50Data, ['totalDistance'], ['desc'])
                      return <BarTeam dataSource={Top50Data} distanceUnit={rankMode === 'utpscore' ? 'points' :'km'}/>
                    }} 
                  </Query>
                  :<Table
                    showHeader={false}
                    rowKey={'participantId'}
                    dataSource={filterData}
                    columns={columns}
                    pagination={{
                      size: 'small',
                      current: this.state.page,
                      pageSize: 50,
                      total: countUser,
                      itemRender: itemRender,
                      onChange: onLoadMore }} />
                }
            </Col>
          </React.Fragment>

          }
           
        </Row>
    );  
  }
}

export default 
compose(
  withApollo,
  withRouter,
  graphql(totalDistanceParticipantStat, {
    props: (props) => {
      const { data } = props
      return {
        totalDistanceParticipantLoading: data.loading,
        totalDistanceParticipantStat: data.totalDistanceParticipantStat,
        fetchMore: data.fetchMore,
      }
    },
    options: (props) => ({
      variables: { 
        eventId: props.eventId,
        ..._get(props, "raceId")
          ? {raceId: _get(props, "raceId")}
          : {},
        perPage: 50,
        page: 1,
      },
      client : raceClient,
    })
  }),

  withTracker,
)(Normal);
